// ##### 25-02-05 Komarov
import { Input } from 'antd';
import uniqueId from 'lodash.uniqueid';
import React from 'react';
import { useSelector } from 'react-redux';

// ##### Komarov 2025-07-14
const CharterComponent = ({ props }) => {
  const { maxLength, AddCharterComments, charterComments } = props;
  // ##### Komarov 2025-08-05
  const charterCommentsMessage = useSelector(state => state.pagesRedux[state.language]?.Charter || '');
  // ##### 23-10-17 Komarov
  const { TextArea } = Input;

  return (
    <div key={uniqueId()} className="form-block-lf">
      <span>{charterCommentsMessage}</span>
      <TextArea
        rows={1}
        maxLength={maxLength}
        style={{ marginTop: '0.5vh', marginBottom: '0.5vh' }}
        onChange={AddCharterComments}
        value={charterComments}
      />
    </div>
  );
};

// ##### 25-05-21 Komarov
export default CharterComponent;
